function Step2FabYouthContent({
  templateState,
  setTemplateField,
}) {
  return (
    <div className="card">
      <h2>FAB Youth Content</h2>

      <label className="field">
        <span>Hero Title</span>
        <input
          type="text"
          value={templateState.hero_title || ""}
          onChange={(e) =>
            setTemplateField("hero_title", e.target.value)
          }
          placeholder="3 ON 3"
        />
      </label>

      <label className="field">
        <span>Intro Section Title</span>
        <input
          type="text"
          value={templateState.intro_section_title || ""}
          onChange={(e) =>
            setTemplateField(
              "intro_section_title",
              e.target.value
            )
          }
          placeholder="WHAT IS 3 ON 3 BASKETBALL?"
        />
      </label>

      <label className="field">
        <span>Intro Text</span>
        <textarea
          rows="5"
          value={templateState.intro_text || ""}
          onChange={(e) =>
            setTemplateField("intro_text", e.target.value)
          }
          placeholder="3-on-3 basketball is a fast-paced and exciting variation of traditional basketball where teams of three players compete against one another..."
        />
      </label>

      <label className="field">
        <span>Benefits Section Title</span>
        <input
          type="text"
          value={templateState.benefits_section_title || ""}
          onChange={(e) =>
            setTemplateField(
              "benefits_section_title",
              e.target.value
            )
          }
          placeholder="WHY 3 ON 3?"
        />
      </label>

      <label className="field">
        <span>Benefits</span>
        <textarea
          rows="14"
          value={templateState.benefits_lines_text || ""}
          onChange={(e) =>
            setTemplateField(
              "benefits_lines_text",
              e.target.value
            )
          }
          placeholder={`Enhanced Skill Development
More Touches on the Ball: With fewer players on the court, each player has more opportunities to handle the ball, improving their dribbling, passing, and shooting skills.
Versatility: Players are encouraged to develop a well-rounded skill set since they will play both offensive and defensive roles, allowing them to learn various aspects of the game.

Increased Participation
Smaller Teams: The smaller team size allows for more involvement, ensuring that all players are engaged in the game rather than being sidelined.
Friendlier Atmosphere: 3-on-3 promotes a more intimate setting where players can bond and build friendships, enhancing the overall enjoyment of the sport.

Faster Game Pace
Quick Matches: Games are typically shorter, leading to quicker rotations and allowing players to participate in multiple games in one day.
Less Downtime: The fast pace minimizes waiting times between plays, creating a more exciting and dynamic environment.`}
        />

        <div className="field-help">
          Put the section title on its own line. Under it, use
          Label: Description. Leave a blank line before the next
          section.
        </div>
      </label>

      <label className="field">
        <span>Benefits Closing Text</span>
        <textarea
          rows="4"
          value={templateState.benefits_closing_text || ""}
          onChange={(e) =>
            setTemplateField(
              "benefits_closing_text",
              e.target.value
            )
          }
          placeholder="FAB’s 3-on-3 format offers a unique and engaging approach to basketball, emphasizing skill development, teamwork, and community..."
        />
      </label>

      <label className="field">
        <span>Register Section Title</span>
        <input
          type="text"
          value={templateState.register_section_title || ""}
          onChange={(e) =>
            setTemplateField(
              "register_section_title",
              e.target.value
            )
          }
          placeholder="HOW TO REGISTER"
        />
      </label>

      <label className="field">
        <span>Register Text</span>
        <textarea
          rows="3"
          value={templateState.register_text || ""}
          onChange={(e) =>
            setTemplateField("register_text", e.target.value)
          }
          placeholder="Email us to register and learn more about upcoming youth 3-on-3 opportunities."
        />
      </label>
    </div>
  );
}

export default Step2FabYouthContent;